import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px 24px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
  gap: 14px;
  flex-wrap: wrap;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const SalesOptionContainer = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 260px;
  max-width: 380px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }
`;

export const UserNameText = styled.p`
  margin-bottom: 0px;
  font-size: 18px;
  font-weight: bold;
`;

export const StationText = styled.p`
  margin: 0px;
`;

export const EstimatedTimeText = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    text-align: center;
  }
`;

export const EstimatedTimeValue = styled.p`
  font-weight: bold;
  margin: 0;
  margin-left: 5px;
  color: ${Colors.primary[100]};
  font-size: 1rem;
`;

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const UserStationContainer = styled.div`
  flex: 1;
  margin-right: 20px;
  justify-items: right;
`;

export const EstimatedTimeContainer = styled.div`
  flex: 1;
  margin-left: 20px;
  margin-top: 16px;
  font-size: 20px;
  justify-items: left;

  @media (max-width: 768px) {
    margin: 0;
    margin-top: 12px;
    font-size: 0.95rem;
    text-align: center;
  }
`;
